import { Box, Divider, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const PowerBi = () => {
    const iframeRef = useRef(null);
    const { company } = useSelector((state) => state.company);
    const { engagementTotal } = useSelector((state) => state.totalEngagement);
    const [urls, setUrls] = useState({
        publicUrl: '',
        reportUrl: ''
    });
    const adjustIframeHeight = () => {
        const iframe = iframeRef.current;
        if (iframe) {
            try {
                iframe.style.height =
                    iframe.contentWindow.document.body.scrollHeight + 'px';
            } catch (error) {
                console.error('Error adjusting iframe height:', error.message);
            }
        }
    };
    
    const powerBIUrl =
        'https://app.powerbi.com/view?r=eyJrIjoiNjNhNTA5YTktNjhjNC00NzE5LTk2OWYtOWQxMmU5MWJlNTVmIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9&pageName=ReportSection';
    const handlePowerBILinks = () => {
        let publicUrl =
            'https://app.powerbi.com/view?r=eyJrIjoiNjNhNTA5YTktNjhjNC00NzE5LTk2OWYtOWQxMmU5MWJlNTVmIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9&pageName=ReportSection';
        let reportUrl =
            'https://app.powerbi.com/view?r=eyJrIjoiMmFkZDQyNzUtZjA0MC00NTE1LWFlNjgtNDliZGViODdkMDA0IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9&pageName=ReportSection';
        switch (company.id) {   
        case 66:
            publicUrl = 
                        'https://app.powerbi.com/view?r=eyJrIjoiMTgwNGU4YmUtZDZkYi00MTJkLTg0YTctNjJiYzY3ZGJiMWFlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
            reportUrl = 
                        'https://app.powerbi.com/view?r=eyJrIjoiMTgwNGU4YmUtZDZkYi00MTJkLTg0YTctNjJiYzY3ZGJiMWFlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
            break;
        case 161:
            publicUrl = 
                            'https://app.powerbi.com/view?r=eyJrIjoiMTgwNGU4YmUtZDZkYi00MTJkLTg0YTctNjJiYzY3ZGJiMWFlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
            reportUrl = 
                            'https://app.powerbi.com/view?r=eyJrIjoiMTgwNGU4YmUtZDZkYi00MTJkLTg0YTctNjJiYzY3ZGJiMWFlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
            break;
        case 64:
            publicUrl = 
                            'https://app.powerbi.com/view?r=eyJrIjoiZGNhOGJhODYtNTFhNi00YmQ1LWE0ZmQtZmYzMzhmMTg0NzUyIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
            reportUrl = 
                            'https://app.powerbi.com/view?r=eyJrIjoiZGNhOGJhODYtNTFhNi00YmQ1LWE0ZmQtZmYzMzhmMTg0NzUyIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
            break;      
        default:
            publicUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiODlmOThmMWItNzJkNy00Mjc5LWJkNjctY2RjMWNiMDZiY2MzIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
            reportUrl =
                    'https://app.powerbi.com/view?r=eyJrIjoiODlmOThmMWItNzJkNy00Mjc5LWJkNjctY2RjMWNiMDZiY2MzIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
            break;
        }
        setUrls({
            publicUrl: publicUrl,
            reportUrl: reportUrl
        });
    };

    useEffect(()=>{
        if(company.id){
            handlePowerBILinks();
        }
        
    },[company.id]);

    return (
        <>
            {
                engagementTotal > 0 &&
                <Box>
                    <Divider className="mv-24 border-1-gray" />
                    <Box>
                        <Typography className="text-center text-lg-semi-bold gray-900">
                                Physician Engagement Metrics
                        </Typography>
                    </Box>
                    <Box
                        className={'bg-white border-softer mt-5 mb-5'}
                        sx={{ height: '100vh' }}
                    >
                        {powerBIUrl !== urls?.publicUrl ? (
                            <iframe
                                allowFullScreen="true"
                                ref={iframeRef}
                                src={urls?.reportUrl}
                                style={{
                                    height: '100vh',
                                    width: '100%',
                                    border: 'none'
                                }}
                                title=""
                                onLoad={adjustIframeHeight}
                            />
                        ) : (
                            <iframe
                                allowFullScreen="true"
                                ref={iframeRef}
                                src={urls?.publicUrl}
                                style={{
                                    height: '100vh',
                                    width: '100%',
                                    border: 'none'
                                }}
                                title=""
                                onLoad={adjustIframeHeight}
                            />
                        )}
                    </Box>
                </Box>
            }
        </>
    );
};

export default PowerBi;
